import { v4 as uuid } from 'uuid';

export const CMS_GENERAL_MERIT_TABLE_CONTENT = `
<table id="${uuid()}" class="merit-letter-table-element">
  <tbody>
    <tr>
      <td></td>
      <td></td>
      <td>{placeholder}</td>
      <td>{placeholder}</td>
    </tr>

    <tr>
      <td></td>
      <td></td>
      <td>€X</td>
      <td>€X</td>
    </tr>
  </tbody>
</table>
`;
